import ReferenceIdRow from '@components/ReferenceIdRow';
import { getCorrelationId } from '@src/utils/correlationId';
import React from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { twMerge } from 'tailwind-merge';

import DefaultCloseButton from './DefaultCloseButton';

const commonClassName =
  'capitalize !rounded-lg !m-4 sm:!m-0 !text-white font-semibold items-center gap-4 !pl-4 !pr-2';

const defaultOptions = {
  position: toast?.POSITION?.TOP_RIGHT,
  icon: false,
  closeButton: DefaultCloseButton,
};

type ShowErrorOptions = ToastOptions & {
  correlationId?: string;
};

const showError = (message: string, options?: ShowErrorOptions) => {
  const { correlationId, ...toastOptions } = options ?? {};

  toast?.error?.(
    correlationId ? (
      <div className="flex flex-col gap-2 normal-case font-normal">
        <span className="font-semibold capitalize">{message}</span>
        <ReferenceIdRow correlationId={correlationId} />
      </div>
    ) : (
      message
    ),
    {
      className: twMerge(commonClassName, '!bg-danger-700'),
      ...defaultOptions,
      ...toastOptions,
    },
  );
};

const showErrorWithCorrelation = (
  message: string,
  error: unknown,
  options?: Omit<ShowErrorOptions, 'correlationId'>,
) => {
  showError(message, { ...options, correlationId: getCorrelationId(error) });
};

const showSuccess = (message: string, options?: ToastOptions) => {
  toast?.success?.(message, {
    className: twMerge(commonClassName, '!bg-green-700'),
    ...defaultOptions,
    ...options,
  });
};

const showInfo = (message: string, options?: ToastOptions) => {
  toast?.info?.(message, {
    className: twMerge(commonClassName, '!bg-black'),
    ...defaultOptions,
    ...options,
  });
};

// ts-prune-ignore-next
export { showError, showErrorWithCorrelation, showInfo, showSuccess };
export type { ShowErrorOptions };
